<template>
    <button class="w-192" @click="addComponent">
        <span class="text-body font-semibold mb-8">{{ type }}</span>
    </button>
</template>

<script>
import {mapState, mapActions} from 'pinia';
import {useBrandingStore} from '../../../shared/state/branding';

export default {
    props: {
        type: String,
    },
    computed: {
        ...mapState(useBrandingStore, [ 'addingComponent' ]),
        icon () {
            return this.type + '-component';
        },
    },
    methods: {
        ...mapActions(useBrandingStore, [ 'startConfiguringComponent' ]),
        addComponent () {
            this.startConfiguringComponent({
                type: this.type,
                position: this.addingComponent,
            });
        }
    }
}
</script>
